import { Button, Grid, Paper, TextField } from "@mui/material"
import HeaderAdd from "../../Common/HeaderAdd/HeaderAdd"
import CustomListCategory from "../../Common/CustomListCategory/CustomListCategory"
import { InfinityListItem } from "../../../types/InfinityListItem"
import CustomListCountry from "../../Common/CustomListCountry/CustomListCountry"
import useLang from "../../../hooks/useLang"

interface Props {
  handleSubmit: (e: any) => void
  handleInputChange: (e: any) => void
  getCategory: (category: InfinityListItem) => void
  getCountry: (segmentation: InfinityListItem[]) => void
  countryDefault: InfinityListItem[]
  name_fr: string
  name_en: string
  loading: boolean
  title: string
  category: InfinityListItem
}

export default function FormMaterialType({
  handleSubmit,
  handleInputChange,
  name_fr,
  name_en,
  loading,
  title,
  category,
  countryDefault,
  getCountry,
  getCategory,
}: Props) {
  const { getText } = useLang()
  return (
    <Grid container spacing={3}>
      <Grid item xs={1} md={2} lg={3} />
      <Grid item xs={12} md={8} lg={6}>
        <Paper
          sx={{
            px: 2,
            py: 3,
            position: "relative",
          }}
        >
          <form onSubmit={handleSubmit}>
            <Grid container spacing={3}>
              <Grid item xs={12} lg={12}>
                <HeaderAdd title={title} />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required={true}
                  name="name_fr"
                  type="text"
                  onChange={handleInputChange}
                  label={getText("Nom de type matière en FR")}
                  fullWidth
                  variant="outlined"
                  value={name_fr}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required={true}
                  name="name_en"
                  type="text"
                  onChange={handleInputChange}
                  label={getText("Nom de type matière en EN")}
                  fullWidth
                  value={name_en}
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12}>
                <CustomListCategory
                  categoryDefault={category}
                  getCategory={getCategory}
                />
              </Grid>
              <Grid item xs={12}>
                <CustomListCountry
                  countryDefault={countryDefault}
                  getCountry={(value) =>
                    getCountry(value as InfinityListItem[])
                  }
                  multiple={true}
                  label={getText("Pays*")}
                  required={false}
                />
              </Grid>
              <Grid
                display={"flex"}
                justifyContent={"center"}
                item
                xs={12}
                lg={12}
              >
                <Button
                  type="submit"
                  style={{ background: "#5D490E" }}
                  disabled={loading}
                  variant="contained"
                >
                  {getText("Valider")}
                </Button>
              </Grid>
            </Grid>
          </form>
        </Paper>
      </Grid>
      <Grid item xs={1} md={2} lg={3} />
    </Grid>
  )
}
